import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PostBoardQueueGroupRequest,
  PostBoardQueueGroupResponse,
} from '../types';

export const postBoardQueueGroup = async ({
  pathParams: { organisationId, boardId },
  body,
}: PostBoardQueueGroupRequest) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/queue/groups`;
  const { data } = await apiAuthClient.post<PostBoardQueueGroupResponse>(
    url,
    body,
  );
  return data.data;
};
